module.exports = fox._r("images/reg_right.png", __webpack_public_path__ + "images/reg_right.png");


//////////////////
// WEBPACK FOOTER
// ./images/reg_right.png
// module id = 522
// module chunks = 2